import React from "react"

import styled from "styled-components"

import { spacing } from "@izettle/otto"

import { Cancel } from "@/components/cancel"
import { ProgressBar } from "@/components/progress-bar"

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${spacing.small};
`
const ProgressBarWrapper = styled.div`
  flex: 1;
`

type StepHeaderProps = {
  backUrl: string
  activeStep: 1 | 2 | 3
}

export const StepHeader: React.FC<StepHeaderProps> = ({ backUrl, activeStep }) => {
  const progressPercentage = (activeStep / 3) * 100
  return (
    <Header>
      <Cancel url={backUrl} />
      <ProgressBarWrapper>
        <ProgressBar value={progressPercentage} />
      </ProgressBarWrapper>
    </Header>
  )
}
